import { TasksDailyCtrl } from './tasks.daily.controller';
import template from './tasks.daily.html';

export const tasksDaily: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: TasksDailyCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'E',
  scope: {
    tabName: '=',
    tasks: '=',
    onTaskClick: '&',
  },
});
